import React from 'react';
import classnames from 'classnames';

import styles from './index.module.scss';

interface ITag {
    text: string;
    className?: string;
    amount?: number;
    isAnchor?: boolean;
    canTab?: boolean;
}

const Tag: React.FC<ITag> = ({
    text, className, amount, isAnchor, canTab
}): JSX.Element => {
    const contnet = (
        <span>
            {text}
            {amount !== 0 && `(${amount})`}
        </span>
    );
    if (isAnchor) {
        return (
            <a
                className={classnames(className, styles.tag, styles.isAnchor)}
                href={`/search?key=${encodeURIComponent(text)}&page=1`}
                title={`查看「${text}」相關文章`}
                tabIndex={canTab ? 0 : -1}
            >
                {contnet}
            </a>
        );
    }
    return (
        <div className={classnames(className, styles.tag)}>
            {contnet}
        </div>
    );
};

Tag.defaultProps = {
    className: '', amount: 0, isAnchor: false, canTab: true
};
export default Tag;
